import * as Api from '@/helpers/restApi'

export default {
  state: {
    ShowKeywordsEditor: false,
    KeywordsData: [],
    KeywordsDataFilter: [],
    ChangeKeywordsObj: {},
    SelectedKeywords: [],
    ShowSelectedKeywords: null
  },
  getters: {
    getShowKeywordsEditor: state => state.ShowKeywordsEditor,
    getKeywordsData: state => state.KeywordsData,
    getKeywordsDataFilter: state => state.KeywordsDataFilter,
    getChangeKeywordsObj: state => state.ChangeKeywordsObj,
    getSelectedKeywords: state => state.SelectedKeywords,
    getShowSelectedKeywords: state => state.ShowSelectedKeywords
  },
  mutations: {
    SetShowKeywordsEditor (state, val) {
      state.ShowKeywordsEditor = val
    },
    SetKeywordsList (state, val) {
      state.KeywordsData = val
      state.KeywordsDataFilter = val
    },
    SetKeywordsDataFilter (state, val) {
      state.KeywordsDataFilter = state.KeywordsData.filter((item) => item.Name.toLowerCase().includes(val.toLowerCase()))
    },
    SetChangeKeywordsObj (state, val) {
      state.ChangeKeywordsObj = val
    },
    SetSelectedKeywords (state, val) {
      state.SelectedKeywords = val.id
      state.KeywordsDataFilter[val.indexItem].IsActive = !state.KeywordsDataFilter[val.indexItem].IsActive
    },
    SetShowSelectedKeywords (state, val) {
      state.ShowSelectedKeywords = val
    }
  },
  actions: {
    setKeywordsData ({ state, dispatch, commit }) {
      Api.getApi({
        url: '/api/Products/GetAllSearchTagsByCache'
      })
        .then((data) => {
          if (data.Succeeded) {
            commit('SetKeywordsList', data.Data)
          } else {
            dispatch('setShowErrorModal', data)
          }
        })
    },
    setKeywordsDataServices ({ state, dispatch, commit }) {
      Api.getApi({
        url: '/api/Utilities/GetAllSearchTagsByCache'
      })
        .then((data) => {
          if (data.Succeeded) {
            commit('SetKeywordsList', data.Data)
          } else {
            dispatch('setShowErrorModal', data)
          }
        })
    },
    setKeywordsDataNews ({ state, dispatch, commit }) {
      Api.getApi({
        url: '/api/Articles/GetAllSearchTagsByCache'
      })
        .then((data) => {
          if (data.Succeeded) {
            commit('SetKeywordsList', data.Data)
          } else {
            dispatch('setShowErrorModal', data)
          }
        })
    },
    setKeywordsDataEducation ({ state, dispatch, commit }) {
      Api.getApi({
        url: '/api/Article/AllSearchTags'
      }, 'education')
        .then((data) => {
          if (data.Succeeded) {
            commit('SetKeywordsList', data.Data)
          } else {
            dispatch('setShowErrorModal', data)
          }
        })
    },
    setCheckSearchTag ({ state, dispatch }, obj) {
      Api.putApi({
        url: `/api/Products/CheckCacheSearchTag/${obj.Id}`,
        payload:
          {
            Value: obj.IsActive
          }
      })
        .then((data) => {
          if (!data.Succeeded) {
            dispatch('setShowErrorModal', data)
          }
        })
    },
    setCheckSearchTagNews ({ state, dispatch }, obj) {
      Api.putApi({
        url: `/api/Articles/CheckCacheSearchTag/${obj.Id}`,
        payload:
          {
            Value: obj.IsActive
          }
      })
        .then((data) => {
          if (!data.Succeeded) {
            dispatch('setShowErrorModal', data)
          }
        })
    },
    setCheckSearchTagServices ({ state, dispatch }, obj) {
      Api.putApi({
        url: `/api/Utilities/CheckCacheSearchTag/${obj.Id}`,
        payload:
          {
            Value: obj.IsActive
          }
      })
        .then((data) => {
          if (!data.Succeeded) {
            dispatch('setShowErrorModal', data)
          }
        })
    },
    setCheckSearchTagEducation ({ state, dispatch }, obj) {
      Api.putApi({
        url: `/api/Article/CheckCacheSearchTag/${obj.Id}`,
        payload:
          {
            Value: obj.IsActive
          }
      }, 'education')
        .then((data) => {
          if (!data.Succeeded) {
            dispatch('setShowErrorModal', data)
          }
        })
    },
    setPostKeywords ({ state, commit, dispatch }, obj) {
      return Api.postApi({
        url: '/api/SearchTags',
        payload: {
          Name: obj.Name
        }
      })
        .then((data) => {
          if (data.Succeeded) {
            if (obj.Category === 3) {
              dispatch('setKeywordsData')
            } else if (obj.Category === 2) {
              dispatch('setKeywordsDataNews')
            } else if (obj.Category === 4) {
              dispatch('setKeywordsDataServices')
            }
          } else {
            // окно с ошибкой
            dispatch('setShowErrorModal', data)
          }
        })
    },
    setPostKeywordsEducation ({ state, commit, dispatch }, obj) {
      return Api.postApi({
        url: '/api/SearchTag/CreateSearchTag',
        payload: {
          Name: obj.Name
        }
      }, 'education')
        .then((data) => {
          if (data.Succeeded) {
            dispatch('setKeywordsDataEducation')
          } else {
            // окно с ошибкой
            dispatch('setShowErrorModal', data)
          }
        })
    },
    setChangeKeywordsData ({ state, dispatch }, obj) {
      Api.putApi({
        url: `/api/SearchTags/${obj.Id}`,
        payload: {
          Id: obj.Id,
          Name: obj.Name
        }
      })
        .then((data) => {
          if (data.Succeeded) {
            if (obj.Category === 3) {
              dispatch('setKeywordsData')
            } else if (obj.Category === 2) {
              dispatch('setKeywordsDataNews')
            } else if (obj.Category === 4) {
              dispatch('setKeywordsDataServices')
            }
          } else {
            // окно с ошибкой
            dispatch('setShowErrorModal', data)
          }
        })
    },
    setChangeKeywordsDataEducation ({ state, dispatch }, obj) {
      Api.putApi({
        url: '/api/SearchTag/UpdateSearchTag',
        payload: {
          Id: obj.Id,
          Name: obj.Name
        }
      }, 'education')
        .then((data) => {
          if (data.Succeeded) {
            dispatch('setKeywordsDataEducation')
          } else {
            // окно с ошибкой
            dispatch('setShowErrorModal', data)
          }
        })
    },
    setDeleteKeywords ({ dispatch }, obj) {
      Api.deleteApi({
        url: `/api/SearchTags/${obj.id}`
      })
        .then((data) => {
          if (data.Succeeded) {
            if (obj.category === 3) {
              dispatch('setKeywordsData')
            } else if (obj.category === 2) {
              dispatch('setKeywordsDataNews')
            } else if (obj.category === 4) {
              dispatch('setKeywordsDataServices')
            }
          } else {
            dispatch('setShowErrorModal', data)
          }
        })
    },
    setDeleteKeywordsEducation ({ dispatch }, obj) {
      Api.deleteApi({
        url: `/api/SearchTag/DeleteSearchTag/${obj.id}`
      }, 'education')
        .then((data) => {
          if (data.Succeeded) {
            dispatch('setKeywordsDataEducation')
          } else {
            dispatch('setShowErrorModal', data)
          }
        })
    },
    setUpdateKeywords ({ state, dispatch }, val) {
      Api.putApi({
        url: '/api/Products/UpdateCacheSearchTags'
      })
        .then((data) => {
          if (data.Succeeded) {
            dispatch('setShowSelectedKeywords')
          } else {
            // окно с ошибкой
            dispatch('setShowErrorModal', data)
          }
        })
    },
    setUpdateKeywordsNews ({ state, dispatch }, val) {
      Api.putApi({
        url: '/api/Articles/UpdateCacheSearchTags'
      })
        .then((data) => {
          if (data.Succeeded) {
            dispatch('setShowSelectedKeywordsNews')
          } else {
            // окно с ошибкой
            dispatch('setShowErrorModal', data)
          }
        })
    },
    setUpdateKeywordsServices ({ state, dispatch }, val) {
      Api.putApi({
        url: '/api/Utilities/UpdateCacheSearchTags'
      })
        .then((data) => {
          if (data.Succeeded) {
            dispatch('setShowSelectedKeywordsServices')
          } else {
            // окно с ошибкой
            dispatch('setShowErrorModal', data)
          }
        })
    },
    setUpdateKeywordsEducation ({ state, dispatch }, val) {
      Api.putApi({
        url: '/api/Article/UpdateCacheSearchTags'
      }, 'education')
        .then((data) => {
          if (data.Succeeded) {
            dispatch('setShowSelectedKeywordsEducation')
          } else {
            // окно с ошибкой
            dispatch('setShowErrorModal', data)
          }
        })
    },
    setShowSelectedKeywords ({ state, dispatch, commit }) {
      Api.getApi({
        url: '/api/Products/GetSelectedSearchTagsByCache'
      })
        .then((data) => {
          if (data.Succeeded) {
            commit('SetShowSelectedKeywords', data.Data)
          } else {
            dispatch('setShowErrorModal', data)
          }
        })
    },
    setShowSelectedKeywordsNews ({ state, dispatch, commit }) {
      Api.getApi({
        url: '/api/Articles/GetSelectedSearchTagsByCache'
      })
        .then((data) => {
          if (data.Succeeded) {
            commit('SetShowSelectedKeywords', data.Data)
          } else {
            dispatch('setShowErrorModal', data)
          }
        })
    },
    setShowSelectedKeywordsServices ({ state, dispatch, commit }) {
      Api.getApi({
        url: '/api/Utilities/GetSelectedSearchTagsByCache'
      })
        .then((data) => {
          if (data.Succeeded) {
            commit('SetShowSelectedKeywords', data.Data)
          } else {
            dispatch('setShowErrorModal', data)
          }
        })
    },
    setShowSelectedKeywordsEducation ({ state, dispatch, commit }) {
      Api.getApi({
        url: '/api/Article/GetSelectedSearchTagsByCache'
      }, 'education')
        .then((data) => {
          if (data.Succeeded) {
            commit('SetShowSelectedKeywords', data.Data)
          } else {
            dispatch('setShowErrorModal', data)
          }
        })
    },
    setClearCacheInnerKeywords ({ dispatch }) {
      Api.deleteApi({
        url: '/api/Products/ClearCheckedSearchTags'
      })
        .then((data) => {
          if (!data.Succeeded) {
            dispatch('setShowErrorModal', data)
          }
        })
    },
    setClearCacheInnerKeywordsNews ({ dispatch }) {
      Api.deleteApi({
        url: '/api/Articles/ClearCheckedSearchTags'
      })
        .then((data) => {
          if (!data.Succeeded) {
            dispatch('setShowErrorModal', data)
          }
        })
    },
    setClearCacheInnerKeywordsServices ({ dispatch }) {
      Api.deleteApi({
        url: '/api/Utilities/ClearCheckedSearchTags'
      })
        .then((data) => {
          if (!data.Succeeded) {
            dispatch('setShowErrorModal', data)
          }
        })
    },
    setClearCacheInnerKeywordsEducation ({ dispatch }) {
      Api.deleteApi({
        url: '/api/Article/ClearCheckedSearchTags'
      }, 'education')
        .then((data) => {
          if (!data.Succeeded) {
            dispatch('setShowErrorModal', data)
          }
        })
    },
    setDeleteCacheInnerKeywords ({ dispatch }, id) {
      Api.deleteApi({
        url: `/api/Products/DeleteCacheSearchTag/${id}`
      })
        .then((data) => {
          if (data.Succeeded) {
            dispatch('setShowSelectedKeywords')
          } else {
            dispatch('setShowErrorModal', data)
          }
        })
    },
    setDeleteCacheInnerKeywordsServices ({ dispatch }, id) {
      Api.deleteApi({
        url: `/api/Utilities/DeleteCacheSearchTag/${id}`
      })
        .then((data) => {
          if (data.Succeeded) {
            dispatch('setShowSelectedKeywordsServices')
          } else {
            dispatch('setShowErrorModal', data)
          }
        })
    },
    setDeleteCacheInnerKeywordsNews ({ dispatch }, id) {
      Api.deleteApi({
        url: `/api/Articles/DeleteCacheSearchTag/${id}`
      })
        .then((data) => {
          if (data.Succeeded) {
            dispatch('setShowSelectedKeywordsNews')
          } else {
            dispatch('setShowErrorModal', data)
          }
        })
    },
    setDeleteCacheInnerKeywordsEducation ({ dispatch }, id) {
      Api.deleteApi({
        url: `/api/Article/DeleteCacheSearchTag/${id}`
      }, 'education')
        .then((data) => {
          if (data.Succeeded) {
            dispatch('setShowSelectedKeywordsEducation')
          } else {
            dispatch('setShowErrorModal', data)
          }
        })
    }
  }
}
